import { localStore } from './useLocalStore';
export const getUserToken = () => {
  try {
    const store = localStore.getState();

    const user = store?.user;
    if (user) {
      return user?.token ?? '';
    } else {
      return '';
    }
  } catch (e) {
    return '';
  }
};
export const getDeviceId = () => {
  try {
    const store = localStore.getState();
    const deviceId = store?.deviceId;
    if (deviceId) {
      return deviceId;
    } else {
      return '';
    }
  } catch (e) {
    return '';
  }
};
